import { IApplicationState } from '../../types/redux';
import { getTemplateSpecialPromo } from './templateSpecialPromo/getTemplateSpecialPromo';

export function getPromoColor(state: IApplicationState): string | null {
  return getTemplateSpecialPromo(state)?.colorHex ?? null;
}
